import styles from "./Button.module.scss"
import cx from "classnames";


interface IButton {
  children: React.ReactNode;
  type?: 'primary' | 'secondary' | 'tertiary' | string;
  outline?: boolean;
  onClick?: () => void;
  width?: string;
  color?: string;
  selected?: boolean;
  textColor?: string;
  borderColor?: string;
  fontSize?: number;
  fontWeight?: string;
  borderRadius?: string;
}

const Button: React.FC<IButton> = ({
  children,
  type = 'primary',
  onClick,
  width = 'auto',
  color = '',
  selected = false,
  textColor = '',
  borderColor = '',
  fontSize,
  fontWeight = 'normal',
  borderRadius = ''
}) => {
  return(
    <button
      style={{
        width: width,
        backgroundColor: color,
        color: textColor,
        borderColor: borderColor,
        fontSize: fontSize,
        fontWeight: fontWeight,
        borderRadius: borderRadius
      }}
      onClick={onClick}
      className={cx({[styles.primary] : type === 'primary', 
                     [styles.secondary] : type === 'secondary', 
                     [styles.squareButton] : type === 'squareButton',
                     [styles.tertiary] : type === 'tertiary', 
                     [styles.transparent] : type === 'transparent',
                     [styles.outline] : type === 'outline',
                      [styles.selected] : selected})}
    >
      {children}
    </button>
  )
}

export default Button;